import React, { useState, useEffect } from 'react'
import { Box, Flex, Button, Modal, Text } from '@mantine/core'
import { IconPlus } from '@tabler/icons-react'
import { useSelector, useDispatch } from 'react-redux'
import { getDetailPackingList, deletePackingList } from '../../../../services/packing'
import LoadingData from '../../../ui/LoadingData'
import NoData from '../../../ui/NoData'
import PackageItemsList from './LayoutHelper/PackageItemsList'
import FormAdjustPackageItem from './Form/FormAdjustPackageItem'
import { modalDeleteData } from '../../../ui/Prompt/modalDeleteData'
import { getPackageDetail } from '../../../../store/packageDetail'
import { useParams } from 'react-router-dom'

const PackageShipmentItems = () => {
  const params = useParams()
  const packageId = params.package_id
  const dispatch = useDispatch()
  const { isLoadingPackage, package_items } = useSelector(state => state.package_detail)
  const [loadingPackage, setLoadingPackage] = useState(true)
  const [packageItemsList, setPackageItemsList] = useState([])
  const [openModalForm, setOpenModalForm] = useState(false)
  const [detailData, setDetailData] = useState(null)

  const handleGetDataPackage = async (dataPackageId) => {
    let data = []
    const params = {
      include: 'items,images,creator,updater'
    }
    const response = await getDetailPackingList(dataPackageId, params)
    if (response.success) {
      const dataPacking = response.data.attributes
      const pickIncludedCreator = response.included.creator || []
      const pickIncludedUpdater = response.included.updater || []

      const includedItems = Object.values(response.included.items) || []

      const getDataUser = (userId, included) => {
        let data = null
        const findUser = included[userId]
        if (findUser) {
          data = {
            id: findUser.attributes.id,
            name: findUser.attributes.name
          }
        }
        return data
      }
      
      const remapData = includedItems.map((val) => {
        return {
          item_id: val.attributes.id,
          name: val.attributes.product_name,
          qty: val.attributes.pivot.qty,
          qty_unit: val.attributes.pivot.qty_unit,
          image_url: val.attributes.image_url,
          creator: dataPacking.created_by !== null ? getDataUser(dataPacking.created_by, pickIncludedCreator) : null,
          updater: dataPacking.updated_by !== null ? getDataUser(dataPacking.updated_by, pickIncludedUpdater) : null
        }
      })
      data = remapData
    } else {
      data = []
    }
    return data
  }

  useEffect(() => {
    if (!isLoadingPackage) {
      if (package_items) {
        handleGetItemsPackage(package_items)
      } else {
        setLoadingPackage(false)
      }
    }
    // eslint-disable-next-line
  }, [isLoadingPackage, package_items])

  const handleGetItemsPackage = async (dataPackage) => {
    setLoadingPackage(true)
    try {
      // eslint-disable-next-line
      const remapData = await Promise.all(dataPackage.map(async (val) => {
        const getItems = await handleGetDataPackage(val.id)
        return {
          ...val,
          order_items: getItems 
        }
      }))
      setPackageItemsList(remapData)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingPackage(false)
    }
  }

  const actions = {
    edit: (val) => {
      setDetailData(val)
      setOpenModalForm(true)
    },
    delete: (val) => {
      modalDeleteData('package items', val.id, val.marks, deletePackingList, () => [dispatch(getPackageDetail(packageId)), handleGetItemsPackage(package_items)])
    },
  }

  const handleAction = (val, type) => {
    return actions[type](val)
  }

  const onCloseModalForm = () => {
    setOpenModalForm(false)
    setDetailData(null)
  }

  return (
    <Box>
      <Box my={10}>
        <Flex justify='flex-end' align='center' my={20}>
          <Button size='xs' radius='sm' leftSection={<IconPlus size={14} />} onClick={() => setOpenModalForm(true)}>Add Package Item</Button>
        </Flex>
      </Box>
      <Box my={30}> 
        {loadingPackage ? <LoadingData /> : packageItemsList.length > 0 ? <PackageItemsList packageItems={packageItemsList} actionMethod={handleAction} showUser={true} /> : <NoData />}
      </Box>
      <Modal opened={openModalForm} onClose={onCloseModalForm} centered closeOnClickOutside={false} size='75%' title={<Text fw='Bold'>{detailData !== null ? 'Update' : 'Create'} Package Item</Text>} withCloseButton={false}>
        <FormAdjustPackageItem dataItem={detailData} onCloseForm={onCloseModalForm} reloadList={null} />
      </Modal>
    </Box>
  )
}

export default PackageShipmentItems